<div class="job-history" [attr.data-automation-id]="automationId + '-container'">
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
        [requestInfo]="requestInfo" [responseCallback]="responseCallbackHandler"
        [headerTemplate]="jobHistoryHeaderTemplate" [gridContext]="gridContext" [(isBusy)]="isGridBusy"
        [(isBusyMessage)]="isGridBusyMessage" [cellClickedCallback]="cellClickedCallback"
        isGridWithDurationColumn='true' [pagerTemplate]="pagerWithDownloadTemplate">
    </res-generic-grid>

    <ng-template #pagerWithDownloadTemplate>
        <button type="button" [attr.data-automation-id]="automationId + '-download-button'"
            [disabled]="!displayOnlyErrors" class="secondary-button icon-button" (click)="downloadSystemErrorReport()"
            [title]="this.downloadTooltip">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>
    <ng-template #jobHistoryHeaderTemplate>
        <div class='top-header'>
            <div class='top-bar'>
                <span class="title">Job and Error History</span>
                <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                    (click)="openHelp()">
                    <i class="fa fa-question"></i>
                </button>
            </div>
            <div class="buttons-bar">
                <div class="button-group">
                    <button data-automation-id="all-button" type="button" class="all-button"
                        [ngClass]="!displayOnlyErrors ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setDisplayErrors(false)">
                        <div>Jobs</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="displayOnlyErrors"></i>
                    </button>
                    <button data-automation-id="errors-button" type="button" class="error-button"
                        [ngClass]="displayOnlyErrors ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setDisplayErrors(true)" [disabled]="disabledAdvanceSearch">
                        <div>Errors</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="!displayOnlyErrors"></i>
                    </button>
                </div>

                <res-custom-checkbox [automationId]="include-syntax-errors-checkbox"
                    [(ngModel)]="isSyntaxErrorsIncluded" [title]="'Include/exclude &quot;INVALID_ARGUMENT&quot; errors'"
                    content="Include Syntax Errors" [isSkeuomorphic]="true" class="include-syntax-errors"
                    (ngModelChange)="onIncludeSyntaxErrorsChanged()" [labelPaddingLeft]="5" [labelPaddingRight]="5"
                    [automationId]="'include-syntax-errors-toggle'" [isToggleBox]="true">
                </res-custom-checkbox>
                <label class="operation-state-label">Job Status:</label>
                <button data-automation-id="all-operation-state-button" type="button" class="all-operation-state-button"
                    [ngClass]="areAllStatesSelected ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onAllStatesSelectedClicked()">
                    <div>All</div>
                    <i class="fa fa-caret-up up-caret-active" [hidden]="!areAllStatesSelected"></i>
                </button>
                <res-collapsible-toggle-box-group [style.min-width.px]="31" [style.max-width.px]="31"
                    (onToggleValueChanged)="onFilterToggleChanged($event)" [isSkeuomorphic]="true"
                    [hasDeselectAll]="true" [toggleItems]="statusList" [data-automation-id]="'stateToggles'"
                    [buttonTooltip]="'Select job statuses'" [labelPaddingLeft]="5" [labelPaddingRight]="5"
                    removeLeftMargin="true">
                </res-collapsible-toggle-box-group>
            </div>
        </div>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</div>